import { autocompleteClasses, Components, chipClasses, Theme } from '@mui/material';

export const MuiAutocomplete: Components<Theme>['MuiAutocomplete'] = {
  styleOverrides: {
    // Autocomplete renders in a portal under `body`, outside Cloud's `#root` where colorScheme is set.
    // Without this, scrollbars stay on the light scheme.
    paper: ({ theme }) => ({
      colorScheme: theme.palette.mode,
    }),
    listbox: ({ theme }) => ({
      ...theme.mixins.visibleScrollbar,
      backgroundColor: theme.featureFlags.panwRebrandStubYear ? theme.palette.background.popover : undefined,
      // we're fighting the MUI default styles here, so we need to use !important
      [`& .${autocompleteClasses.option}[aria-selected="true"]`]: {
        backgroundColor: `${theme.palette.menu.item.selected} !important`,
        '&:hover': {
          backgroundColor: `${theme.palette.menu.item.hover} !important`,
          color: theme.featureFlags.panwRebrandStubYear ? theme.palette.text.primary : undefined,
        },
        [`&.${autocompleteClasses.focused}`]: {
          backgroundColor: `${theme.palette.menu.item.hover} !important`,
          color: theme.featureFlags.panwRebrandStubYear ? theme.palette.text.primary : undefined,
        },
      },
      [`& .${autocompleteClasses.option}:hover`]: {
        backgroundColor: theme.palette.menu.item.hover,
        color: theme.featureFlags.panwRebrandStubYear ? theme.palette.text.primary : undefined,
      },
      [`& .${autocompleteClasses.option}.${autocompleteClasses.focused}`]: {
        backgroundColor: theme.palette.menu.item.hover,
        color: theme.featureFlags.panwRebrandStubYear ? theme.palette.text.primary : undefined,
      },
    }),
    // Hack to make medium chips in medium autocompletes appear small
    // Can be removed once MultiSelect has been backfilled and MUI's Autocomplete is no longer used directly
    tagSizeMedium: {
      height: '18px',
      margin: '2px',
      [`& .${chipClasses.labelMedium}`]: {
        fontSize: '12px',
        padding: '0 8px',
      },
      // TODO: fix this when we upgrade MUI. This missing fontSizeMedium is fixed in later versions.
      // eslint-disable-next-line chrono-ui/no-hardcoded-chrono-ui-class-names -- fontSizeMedium is not in MUI's SvgIconClasses type (medium is the default)
      [`& .MuiSvgIcon-fontSizeMedium`]: {
        width: '16px',
        height: '16px',
        marginLeft: '-4px',
      },
    },
  },
};
